import React from "react";
import Pagination from "../../../Shared/Pagination";
// import { convertUTCDateLocal } from "../../../../utils/convertionFunc";

const ActivityReportTable = ({ data, currPage, setCurrPage, totalCount }) => {
  const totalPagess = Math.ceil(totalCount / 10);

  return (
    <div
      className={`min-w-full ${
        data ? "w-max" : "w-full"
      } rounded-lg flex justify-center`}
    >
      <table className="w-full overflow-scroll relative">
        <thead className="border rounded-lg">
          {" "}
          <tr>
            <th>Patient ID</th>
            <th>Patient Name</th>
            <th>Gender</th>
            <th>Hospital</th>
            <th>Location</th>
            <th>Doctor</th>
            <th>RPM</th>
            <th>Vitals Days</th>
            <th>Medication Days</th>
            <th>Task Days</th>
          </tr>
        </thead>
        <tbody className="text-center">
          {data?.map((item, idx) => (
            <>
              <tr className="border" key={idx}>
                <td>{item.patientId}</td>
                <td>{`${item.salutation} ${item.firstName} ${item.lastName}`}</td>
                <td>
                  {item.gender === "M"
                    ? "Male"
                    : item.gender === "F"
                    ? "Female"
                    : "-"}
                </td>
                <td>{item.hospitalName}</td>
                <td>{item.locationName}</td>
                <td>{item.providerName}</td>
                <td>
                  {item.rpmApplicable === "Y"
                    ? "Yes"
                    : item.rpmApplicable === "N"
                    ? "No"
                    : "-"}
                </td>
                <td>{item.vitalsEnteredCount}</td>
                <td>{item.medicationEnteredCount}</td>
                <td>{item.taskEnteredCount}</td>
              </tr>
            </>
          ))}
        </tbody>
      </table>

      <div className="absolute -bottom-32 right-8 flex justify-end my-2">
        <Pagination
          currentPage={currPage}
          totalPages={totalPagess}
          onPageChange={setCurrPage}
          containerClassName="mb-4"
          buttonClassName="border text border-gray-300 md:px-3 px-2 rounded-full md:py-1 py-0.5 transition duration-300 ease-in-out focus:outline-none hover:bg-gray-200"
          activeButtonClassName="bg-[#3B98B9] rounded-full text-white"
        />
      </div>
    </div>
  );
};
export default ActivityReportTable;
